var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValueSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--fxemoji",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0B3954",
    d: "M500.951 39.183c0-15.84-12.96-28.8-28.8-28.8H35.636c-14.256 0-25.92 11.664-25.92 25.92v439.394c0 14.256 11.664 25.92 25.92 25.92H472.15c15.84 0 28.8-12.96 28.8-28.8V39.183z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B5770",
    d: "M475.031 10.383h-.149v453.166c0 6.6-5.4 12-12 12H9.716v.149c0 14.256 11.664 25.92 25.92 25.92H475.03c14.256 0 25.92-11.664 25.92-25.92V36.303c.001-14.256-11.663-25.92-25.919-25.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F7",
    d: "M175.472 225.184h-24.767a6.577 6.577 0 0 1-6.577-6.577v-108.14c0-5.127-5.606-8.282-9.989-5.622l-19.81 12.023a6.576 6.576 0 0 1-8.924-2.034l-9.589-14.731a6.576 6.576 0 0 1 2.106-9.214l48.038-29.076a6.573 6.573 0 0 1 3.405-.95h26.106a6.577 6.577 0 0 1 6.577 6.577v151.169a6.575 6.575 0 0 1-6.576 6.575z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F7",
    d: "M387.451 104.373c0 23.33-10.358 41.177-51.31 79.53c-4.353 4.077-1.475 11.382 4.489 11.382h42.919c3.99 0 7.061 3.525 6.515 7.477l-2.315 16.745a6.577 6.577 0 0 1-6.515 5.676h-94.892a6.577 6.577 0 0 1-6.577-6.577v-18.142c0-1.759.708-3.447 1.959-4.683c53.286-52.635 65.861-67.586 65.861-87.52c0-13.126-8.021-21.148-20.905-21.148c-10.223 0-17.759 3.939-25.684 12.433a6.573 6.573 0 0 1-8.9.651l-12.691-10.125c-2.932-2.339-3.356-6.687-.846-9.474c12.795-14.213 30.074-23.139 52.011-23.139c36.948 0 56.881 21.391 56.881 46.914z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F7",
    d: "M201.98 307.135c0 14.277-5.964 25.145-16.599 32.261c-4.219 2.823-3.822 9.201.766 11.372c12.55 5.94 21.424 17.515 21.424 36.34c0 27.225-22.121 50.317-62.958 50.317c-22.239 0-39.493-7.288-52.1-19.99c-2.616-2.635-2.612-6.885.074-9.449l12.088-11.538a6.571 6.571 0 0 1 9.002-.067c8.635 8 17.68 11.389 28.507 11.389c14.827 0 25.523-8.508 25.523-23.579c0-16.773-9.481-23.336-26.739-23.336h-6.115c-4.056 0-7.146-3.636-6.49-7.639l2.223-13.585a6.577 6.577 0 0 1 6.49-5.515h3.892c14.341 0 23.336-7.779 23.336-21.148c0-11.91-8.507-18.717-21.635-18.717c-10.292 0-19.016 3.487-27.352 10.165c-2.65 2.123-6.505 1.794-8.832-.678L96.04 292.641c-2.637-2.802-2.298-7.238.693-9.658c14.211-11.496 30.925-17.413 50.312-17.413c35.733-.001 54.935 18.473 54.935 41.565z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F7",
    d: "M341.918 283.373l-32.912 76.324c-1.872 4.341 1.311 9.181 6.039 9.181h13.783a6.576 6.576 0 0 0 6.535-5.837l3.054-26.976a6.576 6.576 0 0 1 6.535-5.837h21.094a6.577 6.577 0 0 1 6.577 6.577v25.497a6.577 6.577 0 0 0 6.577 6.577h5.32a6.577 6.577 0 0 1 6.577 6.577v16.016a6.577 6.577 0 0 1-6.577 6.577h-5.32a6.577 6.577 0 0 0-6.577 6.577v22.093a6.577 6.577 0 0 1-6.577 6.577h-25.01a6.577 6.577 0 0 1-6.577-6.577v-22.093a6.577 6.577 0 0 0-6.577-6.577h-56.366a6.577 6.577 0 0 1-6.577-6.577v-18.064c0-.903.186-1.797.547-2.625l43.648-100.254a6.577 6.577 0 0 1 8.299-3.548l20.715 7.616a6.574 6.574 0 0 1 3.77 8.776z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueSvg);
export default __webpack_public_path__ + "static/media/ValueSVG.a6def459e99ff1c63312e05beb8e2c6a.svg";
export { ForwardRef as ReactComponent };